import { Box, Button, Checkbox, DropDown, Text } from 'dash-ui';
import { Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';

import {
  COMPARISON_DROPDOWN_OPTIONS,
  PropertyCompareItemsEnum,
} from 'containers/portfolio/PropertyComparisonModal/PropertyComparisonModal.constants';

const PropertyComparisonDropDown = ({
  setSelectedCompareOptions,
  selectedCompareOptions,
}: {
  setSelectedCompareOptions: Dispatch<
    SetStateAction<Record<PropertyCompareItemsEnum, boolean>>
  >;
  selectedCompareOptions: Record<PropertyCompareItemsEnum, boolean>;
}) => {
  const { t } = useTranslation();

  const handleComparisonOptions =
    (option: PropertyCompareItemsEnum) => (checked: boolean) => {
      if (checked) {
        return setSelectedCompareOptions((prev) => ({
          ...prev,
          [option]: true,
        }));
      }

      setSelectedCompareOptions((prev) => ({ ...prev, [option]: false }));
    };

  return (
    <DropDown
      Anchor={() => (
        <Button medium mr={2} icon="setting2">
          {t('pages:portfoliosPage.customize')}
        </Button>
      )}
    >
      {() => (
        <Box p={4} w={228}>
          <Text semibold>{t('pages:portfoliosPage.selectItemsToCompare')}</Text>
          <Box>
            {Object.entries(COMPARISON_DROPDOWN_OPTIONS).map(
              ([value, label], index) => {
                const isChecked =
                  selectedCompareOptions[value as PropertyCompareItemsEnum];

                return (
                  <Checkbox
                    mt={3}
                    label={t(label) || ''}
                    checked={isChecked}
                    onChange={handleComparisonOptions(
                      value as PropertyCompareItemsEnum
                    )}
                    key={`${value}-${index}`}
                  />
                );
              }
            )}
          </Box>
        </Box>
      )}
    </DropDown>
  );
};

export default PropertyComparisonDropDown;
